import React, { useState } from "react";
import SEOChecklist from "../../components/admin/SEOChecklist";

const SEOModule = () => {
  const [form, setForm] = useState({
    page: "Home",
    title: "",
    description: "",
    keywords: "",
    canonical: "",
    noIndex: false,
    noFollow: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSave = () => {
    console.log("Saving SEO config:", form);
    // 🔒 Later: Send to backend or save to config file/db
  };

  return (
    <main className="flex-1 p-8 bg-neutral-950 min-h-screen text-white">
      <h1 className="text-3xl font-bold mb-4">🔍 SEO Configuration</h1>
      <p className="text-gray-400 mb-6">Manage meta tags, titles, and visibility rules for search engines.</p>

      <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 space-y-6 shadow-md max-w-3xl">
        {/* Page Selector */}
        <div>
          <label className="block text-sm font-medium mb-1">Select Page</label>
          <select
            name="page"
            value={form.page}
            onChange={handleChange}
            className="w-full bg-neutral-800 border border-neutral-700 rounded px-4 py-2 text-white"
          >
            <option>Home</option>
            <option>About</option>
            <option>Services</option>
            <option>Contact</option>
            <option>Projects</option>
          </select>
        </div>

        {/* Title */}
        <div>
          <label className="block text-sm font-medium mb-1">SEO Title</label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            className="w-full bg-neutral-800 border border-neutral-700 rounded px-4 py-2 text-white"
            placeholder="Enter SEO page title"
          />
        </div>

        {/* Meta Description */}
        <div>
          <label className="block text-sm font-medium mb-1">Meta Description</label>
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            className="w-full bg-neutral-800 border border-neutral-700 rounded px-4 py-2 text-white"
            rows={3}
            placeholder="Write a short description for search engines"
          ></textarea>
        </div>

        {/* Keywords */}
        <div>
          <label className="block text-sm font-medium mb-1">Keywords</label>
          <input
            type="text"
            name="keywords"
            value={form.keywords}
            onChange={handleChange}
            className="w-full bg-neutral-800 border border-neutral-700 rounded px-4 py-2 text-white"
            placeholder="e.g., web development, AI, automation"
          />
        </div>

        {/* Canonical URL */}
        <div>
          <label className="block text-sm font-medium mb-1">Canonical URL</label>
          <input
            type="text"
            name="canonical"
            value={form.canonical}
            onChange={handleChange}
            className="w-full bg-neutral-800 border border-neutral-700 rounded px-4 py-2 text-white"
            placeholder="https://www.blackbear.ca/your-page"
          />
        </div>

        {/* Robots Meta */}
        <div className="flex gap-6">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="noIndex"
              checked={form.noIndex}
              onChange={handleChange}
              className="form-checkbox mr-2"
            />
            <span className="text-sm">No Index</span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="noFollow"
              checked={form.noFollow}
              onChange={handleChange}
              className="form-checkbox mr-2"
            />
            <span className="text-sm">No Follow</span>
          </label>
        </div>

        {/* Save Button */}
        <button
          onClick={handleSave}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2 rounded transition"
        >
          Save SEO Settings
        </button>
      </div>

      {/* Dynamic Checklist */}
      <SEOChecklist />
    </main>
  );
};

export default SEOModule;
